export default {"src":"/_next/static/media/verticalDivider.d88a26c5.svg","height":53,"width":2,"blurWidth":0,"blurHeight":0};